import typeToReducer from 'type-to-reducer'
import {
    GET_DRIVERS_LIST_SUCCESS,
    GET_DRIVERS_LIST_FAIL,
    GET_SINGLE_DRIVER_SUCCESS,
    GET_SINGLE_DRIVER_FAIL } from '../actions/actionTypes';


const initialState = {
    drivers: null,
    driversPageCount: null,
    selected: null,
    error: null
};

const reducer = typeToReducer({
    [GET_DRIVERS_LIST_SUCCESS]: (state, action) => ({
        ...state,
        drivers: action.payload.results,
        driversPageCount: Math.ceil(action.payload.count / 10),
        error: null
    }),
    [GET_DRIVERS_LIST_FAIL]: (state, action) => ({
        ...state,
        error: action.error
    }),
    [GET_SINGLE_DRIVER_SUCCESS]: (state, action) => ({
        ...state,
        selected: action.payload,
        error: null
    }),
    [GET_SINGLE_DRIVER_FAIL]: (state, action) => ({
        ...state,
        error: action.error
    }),
    'START_GET_DRIVERS': (state, action) => ({
        ...state,
        drivers: null,
        error: null
    }),
    'START_GET_DRIVER': (state, action) => ({
        ...state,
        selected: null,
        error: null
    })
}, initialState);


export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/driver.js